import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/film.vue
var s = {
	name: "DtIconFilm",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--film"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Film",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M2.09.5A1.59 1.59 0 0 0 .5 2.09v7.82c0 .878.712 1.59 1.59 1.59h7.82a1.59 1.59 0 0 0 1.59-1.59V2.09A1.59 1.59 0 0 0 9.91.5H2.09ZM4 5.5v-4h4v4H4Zm6.5 0H9V4h1.5v1.5Zm0-3.41a.59.59 0 0 0-.59-.59H9V3h1.5v-.91Zm0 5.91H9V6.5h1.5V8Zm-.59 2.5a.59.59 0 0 0 .59-.59V9H9v1.5h.91ZM1.5 2.09a.59.59 0 0 1 .59-.59H3V3H1.5v-.91ZM3 4H1.5v1.5H3V4ZM1.5 6.5H3V8H1.5V6.5Zm0 3.41c0 .326.264.59.59.59H3V9H1.5v.91ZM8 6.5v4H4v-4h4Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=film.js.map